import { FC } from 'react';
import { Breadcrumb, Card, PageHeader } from "antd";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import TansactionForm from '../components/forms/transaction-form';

const TransactionsFormRoute: FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const id = searchParams.get('id')
  return (
    <>
      <PageHeader
        title="فرم تراکنش کارت به کارت"
        style={{ padding: " 16px 0" }}
        onBack={() => navigate(-1)}
        />
      <Card >
        <TansactionForm />
      </Card>
    </>
  );
}

export default TransactionsFormRoute;
